import React from 'react';
import Image from '../../../img/MainWebsite/DispensaryPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForRestaurants() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent  whiteFont'}>
        <div className={'column'}>
          <h2 className={'left green'}>ELEVATE THE CANNABIS EXPERIENCE</h2>
          <h5 className={'left'}>Designed for Dispensaries: </h5>

          <ul className={"two-columns"}>
            <li className={'green left'}><h5>Supplements in-store menus and boards </h5></li>
            <li className={'green left'}><h5>Accessible on phones or tablets </h5></li>
            <li className={'green left'}><h5>Organizes products clearly  </h5></li>
            <li className={'green left'}><h5>Supports budtenders  </h5></li>
            <li className={'green left'}><h5>Generate an additional revenue stream </h5></li>
            <li className={'green left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk </h5></li>
            <li className={'green left'}><h5>Solely branded for your dispensary </h5></li>
          </ul>
          <h5 className={'left'}>Today’s dispensary customers value clarity, confidence, and a well-organized experience when exploring products. As assortments expand and regulations vary, clear presentation and accurate information matter more than ever. </h5>
          <h5 className={'left'}>Vizo Menu provides a supplemental digital menu experience that helps dispensaries present products clearly,
            consistently, and approachably. Accessible on customers’ own phones or tablets, our menus support exploration
            with helpful details—product descriptions, categories, pricing, and visuals—without replacing existing displays
            or in-store workflows. </h5>
          <h5 className={'left'}>Designed for real-world dispensary environments, Vizo Menu supports budtenders by answering common
            questions upfront and organizing information intuitively. This helps reduce friction at the counter, supports staff
            during busy periods, and creates a more confident, informed purchasing experience. </h5>
          <h5 className={'left'}>Dispensaries can strengthen engagement, support better decision-making,
            and introduce an additional revenue stream through thoughtfully integrated sponsorships that enhance—rather
            than interrupt—the customer experience, while remaining comfortable, compliant, and easy to manage. </h5>
          <h5 className={'left'}>Discreet by design, the experience is solely branded for your dispensary, ensuring customers engage only with
            your offerings, your style, and your brand. </h5>
          <h5 className={'left'}>Best of all, Vizo Menu is provided at no investment. Our business model allows dispensaries to elevate how
            products are presented with no setup fees, no hardware, no training, no downloads, and no financial risk.</h5>
          <h5 className={'green left italic'}>A thoughtful enhancement—designed to support education, confidence, and trust at every interaction. </h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background green-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForRestaurants;